import { query } from "../../../../erd-editor-schema/dist/query/index.js";
import { toOpaqueHex } from "../../../../utils/tableColor.js";
import { getSelectTypeIds } from "./selection.js";
//#region src/engine/modules/editor/utils/color.ts
function getColorTargets({ editor: { selectedMap }, collections }) {
	const { tableIds, memoIds, tableGroupIds } = getSelectTypeIds(selectedMap);
	return {
		tables: query(collections).collection("tableEntities").selectByIds(tableIds),
		memos: query(collections).collection("memoEntities").selectByIds(memoIds),
		tableGroups: query(collections).collection("tableGroupEntities").selectByIds(tableGroupIds)
	};
}
function getColoredSelection(state) {
	const { tables, memos, tableGroups } = getColorTargets(state);
	return {
		tables: tables.filter((table) => table.ui.color !== ""),
		memos: memos.filter((memo) => memo.ui.color !== ""),
		tableGroups: tableGroups.filter((group) => group.color !== "")
	};
}
function hasColoredSelection(state) {
	const { tables, memos, tableGroups } = getColoredSelection(state);
	return tables.length !== 0 || memos.length !== 0 || tableGroups.length !== 0;
}
function getDocumentColors({ doc, collections }) {
	const tables = query(collections).collection("tableEntities").selectByIds(doc.tableIds);
	const memos = query(collections).collection("memoEntities").selectByIds(doc.memoIds);
	const groups = query(collections).collection("tableGroupEntities").selectByIds(doc.tableGroupIds);
	const counts = /* @__PURE__ */ new Map();
	for (const value of [...[...tables, ...memos].map(({ ui }) => ui.color), ...groups.map(({ color }) => color)]) {
		const color = toOpaqueHex(value);
		if (color) counts.set(color, (counts.get(color) ?? 0) + 1);
	}
	return [...counts].sort(([, a], [, b]) => b - a).map(([color]) => color);
}
//#endregion
export { getColorTargets, getColoredSelection, getDocumentColors, hasColoredSelection };
